import { useEffect, useRef, useState } from "react";
import { Globe, Check } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { LANGS } from "../i18n/dictionaries";

export function LanguageSwitcher({ dark = false, testid = "language-switcher" }) {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        data-testid={testid}
        onClick={() => setOpen(!open)}
        title="Idioma / Language / Langue"
        className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
          dark ? "bg-white/10 text-white hover:bg-white/20 border border-white/20" : "border border-slate-200 text-slate-600 hover:border-slate-400 bg-white"
        }`}
      >
        <Globe className="w-3.5 h-3.5" /> {lang.toUpperCase()}
      </button>
      {open && (
        <div className="absolute right-0 mt-1.5 w-36 bg-white border border-slate-200 rounded-xl shadow-lg overflow-hidden z-50" data-testid={`${testid}-panel`}>
          {LANGS.map((l) => (
            <button
              key={l.code}
              type="button"
              data-testid={`lang-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center justify-between px-3.5 py-2 text-sm transition-colors hover:bg-slate-50 ${lang === l.code ? "text-sky-700 font-semibold" : "text-slate-700"}`}
            >
              {l.label}
              {lang === l.code && <Check className="w-3.5 h-3.5" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
